/*
 * followfood (#56): Quickview für die Kisten-PDP-Kacheln.
 *
 * Klick auf eine Kachel (.ff-kiste-tile) öffnet ein Overlay in DERSELBEN Optik wie der
 * Bundle-Builder-Quickview (ff-bundle-cards): zweispaltig (Bild links, Info rechts) mit
 * denselben .ff-qv-*-Klassen für Titel/Subtitle, Gewicht, Zertifizierungs-Siegel und die
 * PDP-Detail-Tabs. Bewusst OHNE Preis/Grundpreis und Badges (Kundenwunsch: auf Kisten-
 * Seiten keine Einzelpreise/Badges — den Preis trägt die Kiste selbst).
 *
 *   - Header/Info: aus window.ffKisteData[handle] (analog window.ffBundleData beim Builder).
 *   - Siegel + Detail-Tabs: on-demand aus fetch('/products/<handle>') (.product-siegel /
 *     .ff-product-detail-section__tabs-column) — genau wie ff-bundle-cards.injectPdpTabs.
 *
 * Robustheit: pro Handle gecacht; Fetch-Guard; Accordions initial zu; Schließen per
 * Backdrop/Button/Escape; Fokus zurück auf das auslösende Element.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-ff-kiste-products]');
  if (!root) return;
  var overlay = root.querySelector('[data-ff-kiste-qv]');
  var body = overlay ? overlay.querySelector('[data-ff-kiste-qv-body]') : null;
  if (!overlay || !body) return;

  // Portal ans <body>: im DOM steckt das Overlay in der Detail-Section, deren
  // .page-width-Wrapper (position:relative; z-index:1) einen Stacking Context bildet —
  // position:fixed + z-index wirken dann nur lokal und nachfolgende Sections
  // (z.B. Tracking-Code) überlagern das Overlay. Gleiches Muster wie der Easify-Quickview.
  document.body.appendChild(overlay);

  var DATA = window.ffKisteData || {};
  var cache = {};   // handle -> { tabs: node|null, siegel: node|null }
  var pending = {};
  var lastFocused = null;
  var currentHandle = null;

  function elc(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = String(text);
    return n;
  }

  // Zweispaltiges Info-Layout wie der Builder-Quickview aufbauen (Bild links, Info rechts).
  function buildLayout(d) {
    var layout = elc('div', 'ff-qv-layout');

    var media = elc('div', 'ff-qv-media');
    if (d.img) {
      var img = elc('img', 'ff-qv-media-img');
      img.src = d.img;
      img.alt = d.t || '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    layout.appendChild(media);

    var info = elc('div', 'ff-qv-info');
    info.appendChild(elc('h2', 'ff-qv-title', d.t || ''));
    if (d.s) info.appendChild(elc('p', 'ff-qv-subtitle', d.s));

    // Kein Preis/Grundpreis im Kisten-Quickview — nur das Gewicht als Meta-Info.
    if (d.w) {
      var priceLine = elc('div', 'ff-qv-price-line');
      var meta = elc('div', 'ff-qv-price-meta');
      meta.appendChild(elc('span', 'ff-qv-weight', d.w));
      priceLine.appendChild(meta);
      info.appendChild(priceLine);
    }

    info.appendChild(elc('div', 'ff-qv-siegel-slot'));
    info.appendChild(elc('div', 'ff-qv-tabs-slot'));
    layout.appendChild(info);
    return layout;
  }

  // Siegel + Detail-Tabs aus der echten Produktseite (identisch zu ff-bundle-cards.injectPdpTabs).
  function extract(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var tabs = doc.querySelector('.ff-product-detail-section__tabs-column');
    var siegel = doc.querySelector('.product-siegel-wrap') || doc.querySelector('.product-siegel');
    return { tabs: tabs, siegel: siegel };
  }

  function inject(parts, handle) {
    if (handle !== currentHandle || !parts) return;
    var siegelSlot = body.querySelector('.ff-qv-siegel-slot');
    var tabsSlot = body.querySelector('.ff-qv-tabs-slot');
    if (parts.siegel && siegelSlot && !siegelSlot.firstChild) {
      var sw = elc('div', 'ff-qv-siegel');
      sw.appendChild(document.importNode(parts.siegel, true));
      siegelSlot.appendChild(sw);
    }
    if (parts.tabs && tabsSlot && !tabsSlot.firstChild) {
      var tw = elc('div', 'ff-qv-pdp-tabs');
      tw.setAttribute('lang', 'de');
      tw.appendChild(document.importNode(parts.tabs, true));
      var open = tw.querySelectorAll('details[open]');
      for (var i = 0; i < open.length; i++) open[i].removeAttribute('open');
      tabsSlot.appendChild(tw);
    }
  }

  function loadDetails(handle) {
    if (cache[handle] !== undefined) { inject(cache[handle], handle); return; }
    if (pending[handle]) return;
    pending[handle] = true;
    fetch('/products/' + handle, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        cache[handle] = html ? extract(html) : { tabs: null, siegel: null };
        inject(cache[handle], handle);
      })
      .catch(function () { cache[handle] = { tabs: null, siegel: null }; });
  }

  function openFor(tile) {
    var handle = tile.getAttribute('data-product-handle');
    if (!handle) return;
    var d = DATA[handle] || {};
    currentHandle = handle;
    lastFocused = document.activeElement;
    body.innerHTML = '';
    body.appendChild(buildLayout(d));
    loadDetails(handle);
    show();
  }

  function show() {
    overlay.hidden = false;
    document.body.classList.add('ff-kiste-qv-open');
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    var closeBtn = overlay.querySelector('.ff-kiste-qv__close');
    if (closeBtn) closeBtn.focus();
  }

  function hide() {
    overlay.classList.remove('is-open');
    document.body.classList.remove('ff-kiste-qv-open');
    currentHandle = null;
    window.setTimeout(function () { if (!overlay.classList.contains('is-open')) overlay.hidden = true; }, 250);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  // Getrennte Listener: das Overlay hängt nach dem Body-Portal nicht mehr unter root.
  root.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-ff-kiste-tile]');
    if (tile) openFor(tile);
  });

  overlay.addEventListener('click', function (e) {
    if (e.target.closest('[data-ff-kiste-qv-close]')) hide();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) hide();
  });
})();
